import { atom } from "jotai";

export const formulario = atom([]);